var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 64,
    viewBox: "0 0 80 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0493 31.1174L77.9094 19.2572C79.4537 17.7138 79.4537 15.2104 77.9094 13.6669L66.0493 1.80672C64.5055 0.262985 62.0027 0.262985 60.4589 1.80672C58.9152 3.35045 58.9152 5.85333 60.4589 7.39706L65.5703 12.5088H23.72C21.5366 12.5088 19.7666 14.2788 19.7666 16.4622C19.7666 18.6456 21.5366 20.4156 23.72 20.4156H65.5703L60.4585 25.5273C58.9145 27.0709 58.9146 29.5741 60.4589 31.1174C62.0024 32.6617 64.5058 32.6617 66.0493 31.1174V31.1174Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6087 62.2968C20.1524 60.7531 20.1524 58.2503 18.6087 56.7065L13.4971 51.5949H55.3474C57.5308 51.5949 59.3008 49.8249 59.3008 47.6415C59.3008 45.4581 57.5308 43.6881 55.3474 43.6881H13.4971L18.6088 38.5764C20.1525 37.0327 20.1524 34.5298 18.6087 32.9861C17.0649 31.4424 14.5621 31.4425 13.0184 32.9862L1.15826 44.8465C-0.386108 46.3899 -0.386108 48.8933 1.15826 50.4368L13.0184 62.2968C14.562 63.8406 17.0649 63.8406 18.6087 62.2968V62.2968Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.773baa7a4034b2643f3e5a75ef585322.svg";
export { ForwardRef as ReactComponent };